__turbopack_context__.v({
  "btnPrimary": "modal-module__EUnqPG__btnPrimary",
  "btnSecondary": "modal-module__EUnqPG__btnSecondary",
  "btnSecondaryBrand": "modal-module__EUnqPG__btnSecondaryBrand",
  "btnUndo": "modal-module__EUnqPG__btnUndo",
  "indicatorActive": "modal-module__EUnqPG__indicatorActive",
  "indicatorCircle": "modal-module__EUnqPG__indicatorCircle",
  "indicatorEmpty": "modal-module__EUnqPG__indicatorEmpty",
  "indicatorText": "modal-module__EUnqPG__indicatorText",
  "indicatorTextActive": "modal-module__EUnqPG__indicatorTextActive",
  "indicatorWave": "modal-module__EUnqPG__indicatorWave",
  "modalActions": "modal-module__EUnqPG__modalActions",
  "modalBackBtn": "modal-module__EUnqPG__modalBackBtn",
  "modalBar": "modal-module__EUnqPG__modalBar",
  "modalBodyContent": "modal-module__EUnqPG__modalBodyContent",
  "modalBodyPlaceholder": "modal-module__EUnqPG__modalBodyPlaceholder",
  "modalCard": "modal-module__EUnqPG__modalCard",
  "modalCloseIconBtn": "modal-module__EUnqPG__modalCloseIconBtn",
  "modalFooter": "modal-module__EUnqPG__modalFooter",
  "modalFooterIndicator": "modal-module__EUnqPG__modalFooterIndicator",
  "modalHeader": "modal-module__EUnqPG__modalHeader",
  "modalHeaderLeft": "modal-module__EUnqPG__modalHeaderLeft",
  "modalHeaderRight": "modal-module__EUnqPG__modalHeaderRight",
  "modalHeaderTitle": "modal-module__EUnqPG__modalHeaderTitle",
  "modalIcon": "modal-module__EUnqPG__modalIcon",
  "modalOverlay": "modal-module__EUnqPG__modalOverlay",
});
